import { sanityImage } from '@/utils/sanityImage';
import cn from 'classnames';
import { useKeenSlider } from 'keen-slider/react';
import Image from 'next/image';
import { FC, useMemo, useState } from 'react';
import { BsArrowLeft, BsArrowRight } from 'react-icons/bs';
import Lightbox, { Slide } from 'yet-another-react-lightbox';
import styles from './RoomDetailsCarousel.module.css';
import { RoomDetailsCarouselProps } from './RoomDetailsCarousel.props';

// const animation = { duration: 5000, easing: (t) => t };

const RoomDetailsCarousel: FC<RoomDetailsCarouselProps> = ({ images }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const [isLightBoxOpen, setIsLightBoxOpen] = useState(false);

  const [sliderRef, slider] = useKeenSlider(
    {
      slideChanged(s) {
        setCurrentSlide(s.track.details.rel);
      },
      loop: true,
      mode: 'snap',
    },
    [
      (_slider) => {
        let timeout: any;
        let mouseOver = false;

        function clearNextTimeout() {
          clearTimeout(timeout);
        }

        function nextTimeout() {
          clearTimeout(timeout);

          if (mouseOver) return;
          timeout = setTimeout(() => {
            _slider.next();
          }, 2000);
        }
        _slider.on('created', () => {
          _slider.container.addEventListener('mouseover', () => {
            mouseOver = true;
            clearNextTimeout();
          });
          _slider.container.addEventListener('mouseout', () => {
            mouseOver = false;
            nextTimeout();
          });
          nextTimeout();
        });
        _slider.on('dragStarted', clearNextTimeout);
        _slider.on('animationEnded', nextTimeout);
        _slider.on('updated', nextTimeout);
      },
    ],
  );

  const handleSlideClick = () => {
    setIsLightBoxOpen(true);
  };


  const lightBoxSlides=useMemo<Slide[]>(() => images?.map((item) => ({
    src: sanityImage(item)?.width(1920).height(1200).url() || ''
  })) ||[],[images]);

  return (
    <div className={styles.roomDetailsCarouselWrapper}>
      <div className={styles.carouselWrapper}>
        <div ref={sliderRef} className={`${styles.carousel} keen-slider`}>
          {images?.map((image) => (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
            <div onClick={handleSlideClick} key={image?._key} className={`${styles.itemCarousel} keen-slider__slide`}>
              <Image
                src={sanityImage(image)?.width(1920).height(1200).url() || ''}
                alt="Room view"
                width={1920}
                height={1200}
                loading="eager"
              />
            </div>
          ))}
          {Array.isArray(images) && slider && (
            <>
              <button
                type="button"
                className={cn(styles.arrow, styles.arrow_left)}
                onClick={() => slider.current?.prev()}
              >
                <BsArrowLeft />
              </button>
              <button
                type="button"
                className={cn(styles.arrow, styles.arrow_right)}
                onClick={() => slider.current?.next()}
              >
                <BsArrowRight />
              </button>
            </>
          )}
        </div>

        <Lightbox
          open={isLightBoxOpen}
          index={currentSlide}
          close={() => setIsLightBoxOpen(false)}
          slides={lightBoxSlides}
        />

      </div>
    </div>
  );
};

export { RoomDetailsCarousel };
